import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import  { fncManifestDetails } from '../Utility/ApiCall.js';
import { flightManifestDetails } from '../ReduxState';

function ManifestSubHeader() {
    const dispatch = useDispatch();
    const SearchedRecordData = useSelector(state => state.search.SearchedRecordData);
    const manifest = useSelector(state => state.sidemenu.manifestDetails);
    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);

    useEffect(() => {
        let selectedSegment = [];
        let apiRequest = {};
        if (SearchedRecordData.length && SearchedFlightDetails && SearchedFlightDetails.recordLocator && manifest === null) {
            let shouldSkip = false;
            SearchedRecordData.forEach(items => {
                items.passengerData.forEach(p => {
                    if (shouldSkip) {
                        return;
                    }
                    selectedSegment = p.segments.filter(s => s.IsSelected);
                    if (selectedSegment.length) {
                        shouldSkip = true;
                        return;
                    }
                });
            });
            if (selectedSegment.length) {
                apiRequest = {
                  Date: selectedSegment[0].departureTime,
                  DepartureStation: selectedSegment[0].origin,
                  ArrivalStation: selectedSegment[0].destination,
                  FlightNo: selectedSegment[0].flightNumber,
                  CarrierCode: selectedSegment[0].carrierCode
                }
                fncManifestDetails(apiRequest)
                .then((response) => {
  
                  if (response.status == "401" && response.data == "") {
                    console.log(response.statusText);
                  }else {
                    if (!response.data.isError) {
                            // console.log('response.data', response);
                            dispatch(flightManifestDetails(
                                    {
                                            type: "",
                                            manifestDetails: {
                                                    totalManifestCounts: response.data.totalManifestCounts,
                                                    passengerSummaries: response.data.passengerSummaries
                                            }
                                    }
                            ));
                    } else {
                            // notify(response.data.errorDetail.errorMessage);
                            console.log(response.data.errorDetail);
                    }
                }
                })
            }
        }

    }, [SearchedRecordData, manifest]);

    return (
       
        manifest ? 
        <div class='container-fluid'>
            <div class="sub-header-content">
                <div class="sub-header-content-data">
                    <p class="font-sm mid-dark-text mb-0"><span class="bold me-1 dark-text">Manifest Count:</span>{manifest.totalManifestCounts.totalManifested}</p>
                </div>
                <div class="sub-header-content-data">
                    <p class="font-sm mid-dark-text mb-0"><span class="bold me-1 dark-text">Checked-in Count:</span>{manifest.totalManifestCounts.totalCheckIn}</p>
                </div>
                <div class="sub-header-content-data">
                    <p class="font-sm mid-dark-text mb-0"><span class="bold me-1 dark-text">No Show Count:</span>{manifest.totalManifestCounts.totalNoShow}</p>
                </div>
                <div class="sub-header-content-data">
                    <p class="font-sm mid-dark-text mb-0"><span class="bold me-1 dark-text">Stand By Count:</span>{manifest.totalManifestCounts.totalStandby}</p>
                </div>
                <div class="sub-header-content-data">
                    <p class="font-sm mid-dark-text mb-0"><span class="bold me-1 dark-text">Boarded Count:</span>{manifest.totalManifestCounts.totalBoarded}</p>
                </div>
            </div>
        </div>
        : null     
    );
}

export default ManifestSubHeader;